import Head from 'next/head';
import { LocaleEnum } from 'schema/locale';
import { PageTranslation } from 'schema/studio/studio';
import { getCanonicalLink } from 'shared/utils/getCanonicalLink';
import { getHreflangLinks } from 'shared/utils/getHreflangLinks';

import type { JSX } from 'react';

type Props = {
  translations?: (PageTranslation | null | undefined)[];
};

const getLinksForTranslations = (translations: PageTranslation[]): JSX.Element[] => {
  if (!translations.length) return [];
  // Map locales to their specific slugs (if slugs differ per locale)
  const localeToSlug = new Map<LocaleEnum, string>(
    translations.map((t) => [t.language as LocaleEnum, t.slug.current])
  );

  const defaultSlug = localeToSlug.get(LocaleEnum.enUS) || translations[0]?.slug.current || '';

  const links = getHreflangLinks(defaultSlug, { xDefault: { slug: defaultSlug } }).map(
    ({ lang, locale }) => {
      const slugForLocale = localeToSlug.get(locale) || defaultSlug;
      return (
        <link
          key={lang}
          rel="alternate"
          hrefLang={lang}
          href={getCanonicalLink(slugForLocale, locale)}
        />
      );
    }
  );

  return links;
};

export const AlternateLinks = ({ translations: initTranslations }: Props) => {
  const translations = (initTranslations || []).filter(
    (i): i is PageTranslation => i !== null && i !== undefined
  );

  const hreflangLinks = getLinksForTranslations(translations);

  return <Head>{hreflangLinks}</Head>;
};
